export default "__VITE_ASSET__BdJKeGHA__"